import { practiceSessionTrackingSerializationModule } from '../serialization';

export const practiceSessionScorm2004TrackingModules = [
  practiceSessionTrackingSerializationModule
]
